import React from "react";
import { Theme, ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { Route, Routes } from "react-router-dom";
import ProtectedRoutes from "./Helpers/ProtectedRoutes";
import Dashboard from "./Components/Dashboard/Dashboard.tsx";
import Login from "./Components/Login/Login";
import Members from "./Components/Members/Members";
import MemberInfo from "./Components/Members/MemberInfo";
import Events from "./Components/Events/Events";
import EventInfo from "./Components/Events/EventInfo.tsx";
import Partnerships from "./Components/Partneships/Partnerships";
import PartnershipsInfo from "./Components/Partneships/PartnershipInfo";
import NewsPage from "./Components/News/NewsPage";
import NewsInfo from "./Components/News/NewsInfo";
import Speakers from "./Components/Speakers/Speakers";
import SpeakersInfo from "./Components/Speakers/SpeakersInfo";
import EventCategoriesView from "./Components/EventCategories/EventCategories.tsx";
import EventCategoryInfo from "./Components/EventCategories/EventCategoryInfo.tsx";
import Guests from "./Components/Guests/Guests.tsx";
import GuestsInfo from "./Components/Guests/GuestsInfo.tsx";
import { DARK_BLUE } from "./Components/StyledComponents/Color/Color";
import ProductListView from "./Components/ProductList/ProductListView.tsx";
import featureFlags from "./featureFlags.json";


const darkTheme: Theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: DARK_BLUE
    }
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "50px"
        },
      },
    },
  },
  typography: {
    button: {
      textTransform: 'none'
    }
  }
})


export default function App() {
  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <Routes>
        <Route path='/login' element={<Login />} />

        <Route element={<ProtectedRoutes />}>
          <Route path="/" element={<Dashboard />}>
            <Route path="members" element={<Members />} />
            <Route path="member/:memberid" element={<MemberInfo />} />

            <Route path="events" element={<Events />} />
            <Route path="event/:eventid" element={<EventInfo />} />

            <Route path="partnerships" element={<Partnerships />} />
            <Route path="partnership/:partnershipid" element={<PartnershipsInfo />} />

            <Route path="news" element={<NewsPage />} />
            <Route path="news/:newsid" element={<NewsInfo />} />

            <Route path="speakers" element={<Speakers />} />
            <Route path="speaker/:speakerid" element={<SpeakersInfo />} />

            <Route path="eventcategories" element={<EventCategoriesView />} />
            <Route path="eventcategory/:eventcategoryid" element={<EventCategoryInfo />} />

            <Route path="guests" element={<Guests />} />
            <Route path="guest/:guestid" element={<GuestsInfo />} />

            {featureFlags.ProductsListEnabled && (
              <Route path="products" element={<ProductListView />} />
            )}
          </Route>
        </Route>
      </Routes>
    </ThemeProvider>
  )
}
